export default __webpack_public_path__ + "static/2025-img-articolo-gennaio2-0e534e148cecb8d9b7c7a3e34c35024a.jpg";